<template>
  <div>
    <div
      :class="[isPdf ? 'pdf-content-layout' : '']"
      v-if="(listType == 'liste' || defaultView == 'liste') && showList"
    >
      <el-row class="mb-10 d-none" v-if="!isPdf">
        <el-col
          :xs="1"
          :sm="1"
          :md="1"
          class="font-weight-bold color-transparent"
        >
          {{ $i18n.t("products.listTypeViewHeading.title") }}
        </el-col>
        <el-col :xs="3" :sm="3" :md="3" class="font-weight-bold text-center">
          {{ $i18n.t("products.listTypeViewHeading.type") }}
        </el-col>
        <el-col
          :xs="2"
          :sm="2"
          :md="2"
          class="text-left font-weight-bold color-transparent"
        >
          {{ $i18n.t("products.listTypeViewHeading.type") }}
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" class="font-weight-bold text-left">
          {{ $i18n.t("products.listTypeViewHeading.nom") }}
        </el-col>

        <el-col :xs="2" :sm="2" :md="2" class="font-weight-bold text-center">
          {{ $i18n.t("products.listTypeViewHeading.annee") }}
        </el-col>
        <el-col :xs="2" :sm="2" :md="2" class="font-weight-bold text-center">
          {{ $i18n.t("products.listTypeViewHeading.volume") }}
        </el-col>
        <el-col
          :xs="3"
          :sm="3"
          :md="3"
          class="text-left font-weight-bold d-none"
          style="padding-left: 15px !important"
        >
          {{ $i18n.t("products.listTypeViewHeading.producteur") }}
        </el-col>
        <el-col :xs="2" :sm="2" :md="2" class="font-weight-bold">
          {{ $i18n.t("products.listTypeViewHeading.qte") }}
        </el-col>
        <el-col :xs="2" :sm="2" :md="2" class="font-weight-bold">
          {{ $i18n.t("products.listTypeViewHeading.prix") }}
        </el-col>
        <el-col :xs="2" :sm="2" :md="2" class="text-left font-weight-bold">
          {{ $i18n.t("products.listTypeViewHeading.disponibilité") }}
        </el-col>
        <el-col :xs="1" :sm="1" :md="1" class="font-weight-bold d-none">
          {{ $i18n.t("products.listTypeViewHeading.TBD") }}
        </el-col>
        <el-col :xs="24" :sm="24" :md="24">
          <el-divider class="m-0 mt-6 mb-6" />
        </el-col>
      </el-row>
      <el-col
        class="type-heading-main"
        v-for="(value, index) in translatedCountriesList"
        :key="index"
      >
        <h1
          class="mb-3 type-country mt-7"
          v-if="getProducteurProduct(value.code).length > 0"
        >
          <el-divider class="m-0 mt-6 mb-6" />
          {{ value.name }}
        </h1>
        <el-col
          class="type-heading-main"
          v-for="(proType, key) in producteurList"
          :key="key"
        >
          <h1
            class="mb-3 type-heading text-uppercase"
            v-if="getProducteurProduct(value.code, proType.name).length > 0"
          >
            {{ proType.name }}
            <span class="type-region mr-5">{{ proType.region }}</span>
            <span class="type-city mr-5" v-if="proType.city != '' && !isMobileLayout">{{
              proType.city
            }}</span>
            <span
              class=""
              v-for="product in getProducteurProduct(value.code, proType.name)"
              :key="product.puid"
            >
              <span v-if="isBiologiqueCheck(product, proType.name)">
                <el-image
                  v-if="isBiologique(product) != ''"
                  class="biologique-logo-list"
                  :src="isBiologique(product)"
                  :fit="'contain'"
                />
              </span>
            </span>
          </h1>
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            v-for="(product, index) in getProducteurProduct(value.code, proType.name)"
            :key="product.puid"
            :span="span"
            :class="[
              isMobileLayout
                ? 'padListElement--mobile product-list-view'
                : 'padListElement product-list-view',

              index === getProducteurProduct(value.code, proType.name).length - 1
                ? 'is-last'
                : ''
            ]"
          >
            <ProductCardListeView
              :product="product"
              :tax-code="taxCode"
              :is-filter-visible="isFilterVisible"
              :is-carousel="isCaroussel"
              :product-type="productType"
              :circleXs="circleXs"
              :typeNameXs="typeNameXs"
              :inventoryXs="inventoryXs"
              :titleXs="titleXs"
              :yearXs="yearXs"
              :volumeXs="volumeXs"
              :caisseXs="caisseXs"
              :priceXs="priceXs"
              :disponibiliteXs="disponibiliteXs"
            />
          </el-col>
        </el-col>
      </el-col>
    </div>
    <div v-else>
      <div v-for="(product, ind) in productList()" :key="ind">
        <el-col
          v-if="checkPriceFilter(product)"
          :span="span"
          :class="isMobileLayout ? 'padListElement--mobile' : 'padListElement'"
        >
          <ProductCard
            :product="product"
            :tax-code="taxCode"
            :is-filter-visible="isFilterVisible"
            :is-carousel="isCaroussel"
            :product-type="productType"
            :minPriceModel="minPriceModel"
            :maxPriceModel="maxPriceModel"
          />
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
import layoutUtils from "@/utils/layout-utils";
import { getDefaultAvailability } from "@/utils/market-utils";
import { sortByHierarchyWithAlternation } from "@/utils/carousel-sort-utils";
import ProductCard from "./product-card.vue";
import ProductCardListeView from "./product-card-liste-view.vue";
import imgProductLeaf from "@/assets/images/product/leaf.png";
import imgProductMoon from "@/assets/images/product/moon.png";
import { isEmpty, get } from "@/utils/lodash";

export default {
  components: {
    ProductCard,
    ProductCardListeView,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    taxCode: {
      type: String,
      default: "IN",
    },
    span: {
      type: Number,
      default: 0,
    },
    isFilterVisible: {
      type: Boolean,
      default: true,
    },
    isCaroussel: {
      type: Boolean,
      default: false,
    },
    productType: {
      type: String,
      default: null,
    },
    listType: {
      type: String,
      default: "tuiles",
    },
    filters: {
      type: Object,
      default: () => ({
        productTypes: [],
        countries: [],
      }),
    },
    minPriceModel: {
      type: Number,
      default: null,
    },
    maxPriceModel: {
      type: Number,
      default: null,
    },
    isPdf: {
      type: Boolean,
      default: false,
    },
    circleXs: {
      type: Number,
      default: 8,
    },
    typeNameXs: {
      type: Number,
      default: 8,
    },
    inventoryXs: {
      type: Number,
      default: 8,
    },
    titleXs: {
      type: Number,
      default: 24,
    },
    yearXs: {
      type: Number,
      default: 4,
    },
    volumeXs: {
      type: Number,
      default: 4,
    },
    caisseXs: {
      type: Number,
      default: 4,
    },
    priceXs: {
      type: Number,
      default: 4,
    },
    disponibiliteXs: {
      type: Number,
      default: 4,
    },
  },
  mounted() {},
  data() {
    return {
      types: [],
      row: 0,
      producteurList: [],
      countriesList: [],
      showList: false,
      defaultView: localStorage.getItem("viewType"),
      productMoonImg: imgProductMoon,
      productLeafImg: imgProductLeaf,
      biologiqueImgArr: [],
      checkIsLeaf: false,
      checkIsMoon: false,
      isBiologiqueImageArr: [],
    };
  },
  computed: {
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    translatedCountriesList() {
    return this.countriesList.map((c) => ({
      code: c.code,
      name: c.name // Example: countries.FR = 'France'
    })).sort((a, b) => a.name.localeCompare(b.name));
  }
  },
  watch: {
    products(val) {
      if (val && val.results) {
        const market = localStorage.getItem("countryCode") || "QC";
        const allowedCodes = getDefaultAvailability(market).map(c => c.toUpperCase());
        val.results.forEach((e) => {
          if (e.productInventories) {
            let price = e.productInventories.find((r) =>
              r.id == e.id && allowedCodes.indexOf(r.inventory.code.toUpperCase()) !== -1
            );
            if (price) {
              e.erpProduct = price;
              e.inventory = price.inventory;
              e.pricing = price.pricing;
            }
          }
        });
      }

      this.reRenderList(true);
    },
    filters(val) {
      if (val && val.countries) {
        this.countriesList = []; // ✅ Clear old list first
        val.countries.forEach((e) => {
          if (e.code) {
            this.countriesList.push({
              code: e.code,
              name: e.name,
            });
          }
        });
      }
    },
  },
  created() {
    this.setproductType();
    this.setproductproducteur();
    this.setCountriesType();
    this.reRenderList(false);
  },
  methods: {
    setproductType() {
      let type = [];
      this.filters.productTypes.forEach((value) => {
        type.push({ code: value.code, name: value.name });
      });
      this.types = type;
    },
    setproductproducteur() {
      let type = [];
      let region = "";
      let city = "";
      let usualName = "";
      this.producteurList = [];
      this.products.forEach((value) => {
        region = "";
        city = "";
        usualName;
        if (value.cmsProvider) {
          if (type.some((e) => e.name == value.cmsProvider.name)) return;
          if (
            !isEmpty(value.origins[0]) &&
            value.origins[0].usualName != undefined
          ) {
            usualName = value.usualName[0].usualName.name;
          }

          if (
            !isEmpty(value.cmsProvider.origins[0]) &&
            value.cmsProvider.origins[0].region != undefined
          ) {
            region = value.cmsProvider.origins[0].region.name;
          }
          if (
            !isEmpty(value.cmsProvider.origins[0]) &&
            value.cmsProvider.origins[0].city != undefined
          ) {
            city = value.cmsProvider.origins[0].city.name;
          }

          type.push({
            name: value.cmsProvider.name,
            usualName: value.cmsProvider.usualName,
            region: region,
            city: city,
          });
        }
      });
      this.producteurList = type;
      this.producteurList.sort(function (a, b) {
        return a.region === b.region ? 0 : a.region < b.region ? -1 : 1;
      });
    },
    setCountriesType() {
      let type = [];
      this.filters.countries.forEach((value) => {
        if (type.some((e) => e == value.code)) return;
        type.push({ code: value.code, name: value.name });
      });
      this.countriesList = type;
      this.countriesList.sort(function (a, b) {
        return a.name === b.name ? 0 : a.name < b.name ? -1 : 1;
      });
    },
    getProducteurProduct(type, proType = "") {
      this.checkIsLeaf = true;
      this.checkIsMoon = true;
      if (proType != "") {
        return this.products.filter(
          (p) =>
            p.id != null &&
            p.origins != "" &&
            p.origins[0].country.code === type &&
            p.cmsProvider &&
            p.cmsProvider.name === proType
        );
      }
      return this.products.filter(
        (p) =>
          p.id != null && p.origins != "" && p.origins[0].country.code === type
      );
    },
    isBiologique(product) {
      const filtered = product.attributes.filter(
        (p) => p.code !== null && p.code !== "" && p.code === "BIO"
      );
      if (!isEmpty(filtered)) {
        return this.productLeafImg;
      }
      const filteredB = product.attributes.filter(
        (p) => p.code !== null && p.code !== "" && p.code === "BIODYNAMICS"
      );
      if (!isEmpty(filteredB)) {
        return this.productMoonImg;
      }
      return "";
    },
    isBiologiqueCheck(product, proTypeName) {
      const filtered = product.attributes.filter(
        (p) => p.code !== null && p.code !== "" && p.code === "BIO"
      );
      var image = this.productMoonImg;
      if (!isEmpty(filtered)) {
        image = this.productLeafImg;
      }
      if (this.isBiologiqueImageArr[proTypeName] == undefined) {
        this.isBiologiqueImageArr[proTypeName] = [image];
        return true;
      } else {
        if (!this.isBiologiqueImageArr[proTypeName].includes(image)) {
          this.isBiologiqueImageArr[proTypeName].push(image);
          return true;
        } else {
          return false;
        }
      }
    },
    productList() {
      let list = this.products;
      if (this.minPriceModel >= 0 && this.maxPriceModel > 0) {
        list = this.products.filter((p) => {
          if (p.erpProduct) {
            if (p.erpProduct.pricing && p.erpProduct.pricing.sellingUnitPrice) {
              return (
                p.erpProduct.pricing.sellingUnitPrice <= this.maxPriceModel
              );
            } else {
              if (this.taxCode === "IN") {
                return p.erpProduct.pricing.priceTaxIn <= this.maxPriceModel;
              } else {
                return p.erpProduct.pricing.price <= this.maxPriceModel;
              }
            }
          }
        });
      }
      // Tile view only: reorder the current page by availability/inventory
      // hierarchy so the most relevant products surface first, instead of the
      // server's country/region origin sort (which puts e.g. South-African
      // products first). List view keeps the origin sort untouched — this
      // method is only used by the tile block. Sorts within the current page.
      const market = localStorage.getItem("countryCode") || "QC";
      return sortByHierarchyWithAlternation(list, market);
    },
    checkPriceFilter(product) {
      if (
        this.maxPriceModel > 0 &&
        this.maxPriceModel != null &&
        this.minPriceModel >= 0 &&
        this.minPriceModel != null &&
        !isEmpty(product)
      ) {
        let price = get(product, "price", 0);
        let agencyFees = get(product, "priceTaxIn", 0);
        if (this.taxCode === "IN") {
          price = get(product, "priceTaxIn", 0);
          if (price === 0 || price == null)
            price = get(product, "price", 0);
          agencyFees = get(product, "priceTaxIn", 0);
        }

        if (price + agencyFees === 0) {
          return true;
        }
        let total = price + agencyFees;
        if (this.maxPriceModel <= total) {
          return true;
        }
      }
      return true;
    },
    reRenderList(reqProd) {
      this.showList = false;
      this.$nextTick(() => {
        if (reqProd == true) {
          this.setproductproducteur();
        }
        this.showList = true;
      });
    },
  },
};
</script>

<style  scoped lang="scss">
.padListElement--mobile {
  padding: 4px 4px 0 4px;
  margin-right: 0;
}
.padListElement {
  padding: 0px 16px 0 0;
  margin-right: 0;        
}
.type-heading {
  padding: 7px 7px 0 7px;
  color: #65666b;
  .type-region {
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
  }

  .type-city {
    font-size: 10px;
    font-weight: 400;
  }
}
.font-weight-bold {
  font-weight: 700;
  font-size: 14px;
}
.color-transparent {
  color: transparent;
}
.type-heading-main {
  h1 {
    font-size: 18px;
    text-align: left;
  }
  .type-country {
    padding: 15px 15px 0 15px;
    font-size: 20px;
    text-align: center;
  }
  .type-region {
    text-transform: uppercase;
  }
  .type-city {
    text-transform: capitalize;
  }
}
.biologique-logo-list {
  margin-left: 2px;
  img {
    margin-top: 2px;
  }
}
.is-last{
  margin-bottom: 15px;
}
</style>
